import { sendVoteRequest } from "../../../api/votify.api";
import participantActions from "./participantActions";

export const handleVote = (vote) => {
  return {
    type: participantActions.HANDLE_VOTE,
    payload: { ...vote, trackUri: vote.trackId },
  };
};

export const handleLoadVotes = (votes) => {
  return { type: participantActions.LOAD_VOTES, payload: votes };
};

export const sendVote = (trackUri) => {
  return async (dispatch, getState) => {
    const partyId = getState().party.partyId;
    const participantId = getState().participant.participantId;
    dispatch({ type: participantActions.START_VOTE_REQUEST });
    dispatch({
      type: participantActions.HANDLE_SEND_VOTE,
      payload: { trackUri },
    });
    const response = await sendVoteRequest(trackUri, partyId, participantId);
    if (response.ok) {
      console.info("Successful vote");
      dispatch({
        type: participantActions.HANDLE_SUCCESS_VOTE,
        payload: { ...response.data, trackUri: response.data.trackId },
      });
    } else {
      dispatch({
        type: participantActions.HANDLE_BAD_VOTE,
        payload: { trackUri },
      });
    }
    dispatch({ type: participantActions.END_VOTE_REQUEST });
  };
};
